import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { paginate, parsePageParam } from '@portal/env/utils/paginate';
import type { PaginateResult } from '@portal/env/utils/paginate';

export function useUrlPagination<T>(
  items: T[],
  pageSize: number,
): PaginateResult<T> {
  const router = useRouter();
  const requested = parsePageParam(router.query.page);
  return useMemo(
    () => paginate(items, requested, pageSize),
    [items, requested, pageSize],
  );
}
